import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import claimEmailTemplateListApi from './list/Api.ClaimEmailTemplate.List';
import claimEmailTemplateSaveApi from './save/Api.ClaimEmailTemplate.Save';
import claimEmailTemplateDeleteApi from './delete/Api.ClaimEmailTemplate.Delete';

export default class ClaimEmailTemplate
  extends Model<Model.IClaimEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimEmailTemplate>
{
  id: number;
  name: string;
  claimStatus: Model.Enum.ClaimStatusCode;
  senderEmail: string;
  senderName: string;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];

  sendToClient = false;
  sendToContactEmail = false;
  sendToClaimOwner = false;
  additionalRecipientEmails: string[] = [];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  constructor(
    data: Partial<Model.IClaimEmailTemplate> | Utils.FormData<Model.IClaimEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ClaimEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await claimEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await claimEmailTemplateSaveApi(this);
  }
  async delete() {
    return await claimEmailTemplateDeleteApi(this.id);
  }
}
